// Footer.jsx
import React from "react";
import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-title">About Thought Box</h3>
          <p className="footer-description">
            ThoughtBox is a space for curious minds to explore, learn, and share
            ideas. It bridges the known and the unknown, encouraging
            conversations across diverse perspectives.
          </p>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li>
              <a href="/blogs">Blogs</a>
            </li>
            <li>
              <a href="/conversations">Conversations</a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>

        {/*      <div className="footer-section">
          <h3 className="footer-title">Topics</h3>
          <ul className="footer-links">
            <li>
              <a href="/tag/ai">Artificial Intelligence</a>
            </li>
            <li>
              <a href="/tag/technology">Technology</a>
            </li>
            <li>
              <a href="/tag/arts">Arts & Culture</a>
            </li>
            <li>
              <a href="/tag/science">Science</a>
            </li>
          </ul>
        </div> */}
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Thought Box. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
